export enum ApplicationType {
	Company = 1,
	Restaurant = 2,
	PrivateLabel = 3,
	Facility = 4,
}
